import React from 'react'
import { useVolunteeringExercise } from './VolunteeringExerciseProvider'
import { useExercise } from '../ExerciseProvider'
import { Label } from '~/lib/ui/label'

const VolunteeringExercisePageTwo = () => {
  const { rankedGoals, pageTwoTranslations } = useVolunteeringExercise()
  const topThreeGoals = rankedGoals
    .filter((goal) => goal.rank !== null)
    .sort((a, b) => a.rank - b.rank)
    .slice(0, 3)

  const { instructions, visit, sites, text_box_label } = pageTwoTranslations

  return (
    <div>
      <div>
        <ol className="list-decimal pl-6">
          {topThreeGoals.map((goal, index) => (
            <li
              key={`top_goal-${index}`}
              className="flex list-decimal items-center gap-2"
            >
              <div className="flex items-center gap-2">{goal.name}</div>
            </li>
          ))}
        </ol>
      </div>
      <div className="mt-4 flex flex-col gap-2">
        <div>{instructions}</div>
        <TextArea label={text_box_label} />
      </div>
      <div className="mt-4">
        <div>{visit}</div>
        <div className="flex flex-col gap-4">
          {sites.map((site, idx) => (
            <Site key={`site-${idx}`} site={site} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default VolunteeringExercisePageTwo

const Site = ({ site }) => {
  const { name, description, url } = site
  return (
    <div>
      <div className="font-bold">
        <a href={url} target="_blank" rel="noopener noreferrer">
          {name}
        </a>
      </div>
      <div className="text-sm">{description}</div>
    </div>
  )
}

const TextArea = ({ label }) => {
  const { getResponse, handleChange } = useExercise()

  const handleTextChange = (e) => {
    handleChange(1, 'ideas', e)
  }

  const textResponse = getResponse(1, 'ideas') || ''

  return (
    <div>
      <Label
        htmlFor="volunteering-ideas"
        className="mb-2 block font-roboto text-base font-bold"
      >
        {label}
      </Label>
      <textarea
        id="volunteering-ideas"
        className="min-h-[125px] w-full rounded-[20px] border border-[#D3D3D3] bg-[#F7FAFC] p-3 font-roboto text-base"
        onChange={handleTextChange}
        value={textResponse}
      />
    </div>
  )
}
